import template from './sidenav.html';
import controller from './sidenav.controller';
import './sidenav.scss';

let sidenavComponent = {
  bindings: {},
  template,
  controller
};

export default sidenavComponent;



// WEBPACK FOOTER //
// ./client/app/common/layout/sidenav/sidenav.component.js